// extracted by mini-css-extract-plugin
module.exports = {"card":"AboutUsCard_card__nz2Bl","small":"AboutUsCard_small__l1snC","title":"AboutUsCard_title__gULuV","text":"AboutUsCard_text__jdJBO"};